import ApiClient from './alms-api';
import { Log, Level, Logger } from 'ng2-logger';

const _logger = Log.create('loginpage-service.ts');
let _apiClient: ApiClient;
export class LoginPageService {
    constructor() {
        _apiClient = new ApiClient();
    }
    public async GetLoginInformation(): Promise<Response> {
        const parsedUrl = new URL(window.location.href);
     
        if (parsedUrl.port === '' && parsedUrl.protocol === 'http:') {
            parsedUrl.port = '3000';
        } else if (parsedUrl.port === '' && parsedUrl.protocol === 'https:') {
            parsedUrl.port = '3000';
        }
        return _apiClient.RequestAsync(
            'POST',
            '/api/organization/logininformation',
            { Address: parsedUrl.hostname, Port: parsedUrl.port }
        );
    }

    public async GetUserIdentity(isAfterChangePassword: boolean): Promise<Response> {
        const parsedUrl = new URL(window.location.href);
        if (parsedUrl.port === '' && parsedUrl.protocol === 'http:') {
            parsedUrl.port = '3000';
        } else if (parsedUrl.port === '' && parsedUrl.protocol === 'https:') {
            parsedUrl.port = '3000';
        }
        return _apiClient.RequestAsync(
            'POST',
            '/api/organization/useridentity',
            isAfterChangePassword
        );
    }
}
